import { TotalDetail } from './TotalDetail'
import { withTotalDetail } from './withTotalDetail'

const ConnectedTotalDetail = withTotalDetail(TotalDetail)

export { ConnectedTotalDetail as TotalDetail }
